import storageManager from '../../services/StorageManager'
import { type CreateOrderParams } from '../../services/OrderManager.types'

const CREATE_ORDER_PARAMS_KEY = 'create-order-params'
const COMPLETED_INTENTS_KEY = 'completed-payment-intents'
export const PAYMENT_INTENT_PARAM = 'payment_intent'

function getCreateOrderParamsKey(paymentIntentId: string) {
  return `${CREATE_ORDER_PARAMS_KEY}-${paymentIntentId}`
}

export function storeCreateOrderParams(
  paymentIntentId: string,
  createOrderParams: CreateOrderParams
) {
  storageManager.set(
    getCreateOrderParamsKey(paymentIntentId),
    createOrderParams
  )
}

export function restoreCreateOrderParams(paymentIntentId: string) {
  return storageManager.get<CreateOrderParams>(
    getCreateOrderParamsKey(paymentIntentId)
  )
}

export function clearCreateOrderParams(paymentIntentId: string) {
  storageManager.remove(getCreateOrderParamsKey(paymentIntentId))
}

export function getCompletedPaymentIntentIds() {
  return storageManager.get<string[]>(COMPLETED_INTENTS_KEY) || []
}

// Save the payment intents that were ordered successfully, to ignore cases when trying to access /post-payment with old values
export function storeCompletedPaymentIntentIds(paymentIntentId: string) {
  const completedIntents = getCompletedPaymentIntentIds()
  completedIntents.push(paymentIntentId)
  storageManager.set(COMPLETED_INTENTS_KEY, completedIntents)
}
